import axios from 'axios';
import React, { useEffect, useState } from 'react';

const EditProfile = () => {


  useEffect(() => {

    axios.get(`${process.env.REACT_APP_API_ROOT}` + "/api/get_eventlist/")
      .then(response => seteventInfo(response.data.data))
      .catch(error => console.error('Error fetching data:', error));
  }, []);




  return (
    <div>
      <p className='font-bebas text-[32px] text-[#1A1A1A] py-6'> Edit Profile</p>
    </div>
  );
};

export default EditProfile;